import { ItAssetsConfigurationListItem, ItAssetsConfigurationPayload, ItAssetsConfigurationResponse, ItAssetsConfigurationError, ItAssetsConfigurationItem, AddItAssetsConfigurationResponse, DeletedItAssetsConfiguration } from '@core/interface/it_assets/itAssetsConfiguration';
import { createActionGroup, props } from '@ngrx/store';

export const ItAssetsConfigurationActions = createActionGroup({
  source: 'ItAssetsConfiguration',
  events: {
    'Load ItAssetsConfiguration List': props<{ key: ItAssetsConfigurationListItem; data: ItAssetsConfigurationPayload }>(),
    'Load ItAssetsConfiguration List Success': props<{
      response: ItAssetsConfigurationResponse;
      key: ItAssetsConfigurationListItem;
    }>(),
    'Load ItAssetsConfiguration List Failure': props<{ error: ItAssetsConfigurationError; key: ItAssetsConfigurationListItem }>(),
    'Add Edit ItAssetsConfiguration': props<{ data: ItAssetsConfigurationItem; key: ItAssetsConfigurationListItem }>(),
    'Update ItAssetsConfiguration Success': props<{
      response: AddItAssetsConfigurationResponse;
      key: ItAssetsConfigurationListItem;
    }>(),
    'Update ItAssetsConfiguration Failure': props<{ error: ItAssetsConfigurationError; key: ItAssetsConfigurationListItem }>(),
    'Delete ItAssetsConfiguration': props<{ id: number; key: ItAssetsConfigurationListItem }>(),
    'Delete ItAssetsConfiguration Success': props<{
      response: DeletedItAssetsConfiguration;
      key: ItAssetsConfigurationListItem;
    }>(),
    'Delete ItAssetsConfiguration Failure': props<{ error: ItAssetsConfigurationError; key: ItAssetsConfigurationListItem }>(),
    'Reset ItAssetsConfiguration Status': props<{ key: ItAssetsConfigurationListItem }>(),
    'Reset ItAssetsConfiguration List': props<{ key: ItAssetsConfigurationListItem }>()
  },
});
